module["exports"] = [
  "სოფელი",
  "ძირი",
  "სკარი",
  "დაბა"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/city_suffix.js
// module id = 1172
// module chunks = 1